export function replaceFailedThumbnails() {
    $('.video-preview img').each(function () {
        $(this).on('load', function () {
            const {src, naturalWidth} = this;
            if (naturalWidth === 120) {
                this.src = src.replace('maxres1.jpg', 'maxresdefault.jpg');
            }
        });
    });
}